<script>
    import Panel from "./content-panel/Panel.svelte";
    import { onMount, onDestroy } from 'svelte';
    import { t, locale, locales } from "../../scripts/i18n";

    export let params = {};
    let divHeight;

    let username = params && params.status ? params.account.username : 'photographer.london';

    onMount(() => {
        window.scrollTo(0, 0);
    });


</script>

<div class="analyze-in-progress-wrap position-relative" style={`min-height: ${divHeight}px;`}>
    <div class="banner-top">

    </div>

    <div class="inner-content-wrap position-absolute top-0 w-100pc" bind:clientHeight={divHeight}>
        <Panel>
            <span slot="icon">
                <img src="/static/media/Vector (14).49e653f6.svg" alt="/" class="scan-block_top-img mr-5px">
            </span>
            <span slot="title">{$t('Management of Bot-Removal subscription')}</span>
            <div slot="content">

                <p class="report_content_text">
                    {$t('We recommend to get Bot-Removal subscribe with full access to all your Instagram accounts, to provide constant protection. Access will be automatically renewed for such accounts.')}
                </p>


                <div class="subscriptions-list-wrap mb-20px">
                    <div class="table-responsive mobile-hide">
                        <div class="table-headers">
                            <div class="w-25pc p-8px report_content-table-th_radius-l ">{$t('Account name')}</div>
                            <div class="w-25pc p-8px ">{$t('Access time')}</div>
                            <div class="w-25pc p-8px ">{$t('Tariff plan')}</div>
                            <div class="w-25pc p-8px ">{$t('Subscription status')}</div>
                        </div>
                        <div class="text-centered empty-table-diagram">
                            <div class="subscription-wrap">
                                <div class="w-25pc p-8px  ">{$t('@photographer.london')}</div>
                                <div class="w-25pc p-8px ">{$t('Until 2023-12-31 12:00:00')}</div>
                                <div class="w-25pc p-8px ">{$t('Full Access ($47)')}</div>
                                <div class="w-25pc p-8px ">
                                    <a href="#">{$t('Cancel subscription')}</a>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div class="tablet-table desktop-hide">
                        <div class="sub-account">
                            <div class="text-center">{$t('Account name')}</div>
                            <div class="text-center">{$t('@photographer.london')}</div>
                            <div class="text-center">{$t('Access time')}</div>
                            <div class="text-center">{$t('Until 2023-12-31 12:00:00')}</div>
                            <div class="text-center">{$t('Tariff plan')}</div>
                            <div class="text-center">{$t('Full Access ($47)')}</div>
                            <div class="text-center">{$t('Subscription status')}</div>
                            <div class="text-center">
                                <a href="#" class="purple-btn purple-btn_hover w-210px h-45px mx-auto">{$t('Cancel subscription')}</a>
                            </div>
                        </div>

                    </div>
                </div>


                {#if (window.language !== 'ru-RU')}
                <div class="table-responsive calm-down-div"
                     style="border: 1px solid rgb(221, 221, 221); padding: 20px 30px;">
                    <svg width="28" height="28" viewBox="0 0 28 28" fill="none" xmlns="http://www.w3.org/2000/svg"
                         style="min-width: 28px; margin-right: 10px; margin-bottom: 20px;">
                        <path d="M14.0001 12.6667C13.6464 12.6667 13.3073 12.8071 13.0573 13.0572C12.8072 13.3072 12.6667 13.6464 12.6667 14V18C12.6667 18.3536 12.8072 18.6928 13.0573 18.9428C13.3073 19.1929 13.6464 19.3333 14.0001 19.3333C14.3537 19.3333 14.6928 19.1929 14.9429 18.9428C15.1929 18.6928 15.3334 18.3536 15.3334 18V14C15.3334 13.6464 15.1929 13.3072 14.9429 13.0572C14.6928 12.8071 14.3537 12.6667 14.0001 12.6667ZM14.0001 8.66667C13.7364 8.66667 13.4786 8.74487 13.2593 8.89138C13.04 9.03789 12.8691 9.24613 12.7682 9.48976C12.6673 9.7334 12.6409 10.0015 12.6924 10.2601C12.7438 10.5188 12.8708 10.7563 13.0573 10.9428C13.2437 11.1293 13.4813 11.2563 13.7399 11.3077C13.9986 11.3592 14.2667 11.3328 14.5103 11.2318C14.7539 11.1309 14.9622 10.96 15.1087 10.7408C15.2552 10.5215 15.3334 10.2637 15.3334 10C15.3334 9.64638 15.1929 9.30725 14.9429 9.0572C14.6928 8.80715 14.3537 8.66667 14.0001 8.66667ZM14.0001 0.666672C12.2491 0.666672 10.5153 1.01155 8.89762 1.68161C7.27994 2.35167 5.81009 3.3338 4.57197 4.57191C2.07149 7.0724 0.666732 10.4638 0.666732 14C0.655076 17.0789 1.72112 20.0647 3.68007 22.44L1.0134 25.1067C0.828389 25.2942 0.70306 25.5323 0.653228 25.7909C0.603396 26.0496 0.631293 26.3172 0.733399 26.56C0.844143 26.7999 1.02367 27.0015 1.24919 27.1392C1.47472 27.2769 1.73607 27.3445 2.00007 27.3333H14.0001C17.5363 27.3333 20.9277 25.9286 23.4282 23.4281C25.9286 20.9276 27.3334 17.5362 27.3334 14C27.3334 10.4638 25.9286 7.0724 23.4282 4.57191C20.9277 2.07143 17.5363 0.666672 14.0001 0.666672ZM14.0001 24.6667H5.2134L6.4534 23.4267C6.57938 23.3032 6.67961 23.1559 6.74827 22.9934C6.81693 22.8309 6.85267 22.6564 6.8534 22.48C6.84839 22.1283 6.70462 21.7928 6.4534 21.5467C4.70751 19.8027 3.6203 17.5074 3.37699 15.0517C3.13368 12.5961 3.74932 10.132 5.11903 8.07937C6.48875 6.02672 8.52779 4.51248 10.8888 3.79464C13.2497 3.07679 15.7865 3.19974 18.067 4.14256C20.3475 5.08537 22.2305 6.78971 23.3953 8.96519C24.5601 11.1407 24.9346 13.6527 24.4549 16.0733C23.9752 18.494 22.6711 20.6734 20.7648 22.2403C18.8584 23.8073 16.4677 24.6647 14.0001 24.6667Z"
                              fill="#4B0082"></path>
                    </svg>
                    <p style="text-align: left; border-bottom-width: 0px;">Please note that some features may not work
                        if your subscription is canceled before the end of your subscription period.<br>We will send you
                        an email 24 hours before your next invoice informing you of the auto-renewal. Please use this
                        time to unsubscribe if you don't want to continue using Bot-Removal anymore.</p></div>
                {/if}

            </div>
        </Panel>
    </div>
</div>

<style>
    .calm-down-div {
        display: flex;
        font-family: "Roboto";
        font-style: normal;
        font-weight: 300;
        font-size: 16px;
        line-height: 19px;
        color: #000
    }

    @media (max-width: 480px) {
        .calm-down-div {
            flex-flow:column
        }
        .mobile-hide {
            display: none;
        }
    }
    @media (min-width: 481px) {
        .desktop-hide {
            display: none;
        }
    }

    .table-headers {
        display: flex;
        justify-content: space-evenly;
        align-items: center;

        text-align: center;
        font-family: Roboto;
        font-style: normal;
        font-size: 16px;
        color: #000;

        background-color: #dddddd;
    }

    .subscription-wrap {
        display: flex;
        justify-content: space-evenly;
        align-items: center;

        text-align: center;
        font-family: Roboto;
        font-style: normal;
        font-size: 16px;
        color: #000;
    }

</style>